<div class="hot-new-tracks__cards">
  @for (track of tracks | slice: 0 : 12; track track) {
    <bmcore-track-item-box class="hot-new-tracks__item" [track]="track" [tracks]="tracks"> </bmcore-track-item-box>
  }
</div>

<div class="hot-new-tracks__slider">
  <bmcore-common-slider [tracks]="tracks"></bmcore-common-slider>
</div>
